export const TRANSACTION = "TRANSACTION"
export const TRANSACTION_SUCCESS = "TRANSACTION_SUCCESS"
export const TRANSACTION_FAILURE = "TRANSACTION_FAILURE"
export const INTERNAL_TRANSACTION = "INTERNAL_TRANSACTION"
export const INTERNAL_TRANSACTION_SUCCESS = "INTERNAL_TRANSACTION_SUCCESS"
export const INTERNAL_TRANSACTION_FAILURE = "INTERNAL_TRANSACTION_FAILURE"
export const SINGLE_TRANSACTION = "SINGLE_TRANSACTION"
export const SINGLE_TRANSACTION_SUCCESS = "SINGLE_TRANSACTION_SUCCESS"
export const SINGLE_TRANSACTION_FAILURE = "SINGLE_TRANSACTION_FAILURE"
export const ADD_TRANSACTION = "ADD_TRANSACTION"
export const ADD_TRANSACTION_SUCCESS = "ADD_TRANSACTION_SUCCESS"
export const ADD_TRANSACTION_FAILURE = "ADD_TRANSACTION_FAILURE"
export const ADD_TRANSACTIONTOCSV = "ADD_TRANSACTIONTOCSV"
export const ADD_TRANSACTIONTOCSV_SUCCESS = "ADD_TRANSACTIONTOCSV_SUCCESS"
export const ADD_TRANSACTIONTOCSV_FAILURE = "ADD_TRANSACTIONTOCSV_FAILURE"
export const ADD_INTERNALTRANSACTION = "ADD_INTERNALTRANSACTION"
export const ADD_INTERNALTRANSACTION_SUCCESS = "ADD_INTERNALTRANSACTION_SUCCESS"
export const ADD_INTERNALTRANSACTION_FAILURE = "ADD_INTERNALTRANSACTION_FAILURE"
export const UPDATETRANSACTION = "UPDATETRANSACTION"
export const UPDATETRANSACTION_SUCCESS = "UPDATETRANSACTION_SUCCESS"
export const UPDATETRANSACTION_FAILURE = "UPDATETRANSACTION_FAILURE"
export const UPDATEINTERNALTRANSACTION = "UPDATEINTERNALTRANSACTION"
export const UPDATEINTERNALTRANSACTION_SUCCESS = "UPDATEINTERNALTRANSACTION_SUCCESS"
export const UPDATEINTERNALTRANSACTION_FAILURE = "UPDATEINTERNALTRANSACTION_FAILURE"